import script from "./CameraDetailsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CameraDetailsPage.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__